<!-- eslint-disable -->
<template lang="pug">
    .achievement-item
        .frame
            img(src="../../../assets/images/Frame.svg")
        .image
            img.achievement-image(:src="imageSrc")
        .description(v-if="achievement.pivot && achievement.pivot.status")
            |  {{ $i18n.t(`achievements.achievement_description_${achievement.name}`) }}
        span.text(:style="{color: !achievement.pivot.status ? '#888888' : ''}")
            | {{ titleText }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            achievement: {
                type: Object,
                default () {
                    return {}
                }
            }
        },
        computed: {
            imageSrc () {
                if (this.achievement) {
                    let path = this.achievement.pivot.status
                            ? this.achievement.image
                            : this.achievement.hiddenImage;
                    return this.$options.filters.apiFile(path);
                }
                return '';
            },
            titleText () {
                if (this.achievement) {
                    if (this.achievement.pivot.status) {
                        return this.$i18n.t(`achievements.achievement_name_${this.achievement.name}`);
                    } else {
                        return this.$i18n.t('achievements.achievement_stars', {price: this.achievement.price});
                    }
                }
                return '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .achievement-item {
        position: relative;
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: center;
        padding: 15px 30px;
        box-sizing: border-box;
        @include media($md) {
            width: 50%;
        }
        @include media($xlg) {
            width: 33.3%;
        }
    }

    .frame {
        display: flex;
        width: 100%;
        img {
            width: 100%;
        }
    }

    .image {
        width: 50%;
        height: 50%;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 20%;
        @include media($md) {
            top: 15%;
        }
        &:hover ~ .description {
            display: block;
            opacity: 1;
        }
    }

    .achievement-image {
        width: 100%;
    }

    .description {
        position: absolute;
        top: 110px;
        width: 250px;
        height: auto;
        border-radius: 10px;
        padding: 27px 30px;
        background-color: $x-color-white;
        box-shadow: 0 0 54px $hsl-color-gray-94;
        font-size: 16px;
        text-align: center;
        opacity: 0;
        transition: all .2s linear;
        cursor: default;
        white-space: pre-line;
        z-index: 1;
        display: none;
        @include media($sm) {
            width: 320px;
        }
        &:hover {
            display: block;
            opacity: 1;
        }
    }

    .text {
        font-size: 22px;
        font-weight: 500;
        margin-top: 20px;
        text-align: center;
    }
</style>
